import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "@/mocks/articles";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-sm border-b border-foreground-100/20"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 h-16 md:h-18" aria-label="主导航">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="51黑料网首页">
          <span className="font-heading text-xl md:text-2xl font-bold text-foreground-900 tracking-tight">
            51<span className="text-primary-500">黑料</span>网
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 ${
                location.pathname === link.path
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about#contact"
            className="whitespace-nowrap text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
          >
            提交爆料
          </Link>
          <Link
            to="/about#contact"
            className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            aria-label="提交爆料"
          >
            <i className="ri-arrow-right-up-line text-sm"></i>
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-900 ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-foreground-100/20 px-4 py-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-3 text-sm font-medium border-b border-foreground-100/10 last:border-0 ${
                location.pathname === link.path
                  ? "text-primary-500"
                  : "text-foreground-700"
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/about#contact"
            className="mt-3 inline-block px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            提交爆料
          </Link>
        </div>
      )}
    </header>
  );
}
